// Environment detection helper
const getEnv = (key: string): string | undefined => {
  // Try Vite's import.meta.env first (for React app)
  if (typeof import.meta !== 'undefined') {
    try {
      const viteEnv = (import.meta as any).env;
      if (viteEnv && viteEnv[key] !== undefined) {
        return viteEnv[key];
      }
    } catch (e) {
      // import.meta not available
    }
  }
  
  // Try Next.js process.env (works in both server and client)
  if (typeof process !== 'undefined' && process.env && process.env[key] !== undefined) {
    return process.env[key];
  }
  
  return undefined;
};

// Environment detection
const getNodeEnv = (): string => {
  return getEnv('NODE_ENV') || 'development';
};

const nodeEnv = getNodeEnv();
const isDevelopment = nodeEnv === 'development';
const isProduction = nodeEnv === 'production';
const isTest = nodeEnv === 'test';

// Base configuration
const baseConfig = {
    app: {
        name: 'Two And Five',
        version: '1.0.0',
        description: 'Fearless. Boundless. Unstoppable. – Affordable Fast Fashion India',
        tagline: 'Fearless. Boundless. Unstoppable.',
        domain: 'twoandfive.in',
        supportEmail: 'contact@nusrif.com',
        privacyEmail: 'contact@nusrif.com',
        address: 'BISHRAMGANJ, AGARTALA, TRIPURA',
    },

    // API Configuration
    api: {
        baseUrl: getEnv('VITE_PUBLIC_API_BASE_URL') || 
                 getEnv('NEXT_PUBLIC_API_BASE_URL') || 
                 'http://localhost:3000/api',
        timeout: 30000, // 30 seconds
        retries: 3,
        cashfree: (getEnv('VITE_CASHFREE_MODE') || getEnv('NEXT_PUBLIC_CASHFREE_MODE')) === 'production' 
                  ? 'production' 
                  : 'sandbox',
    },

    // Region Configuration
    region: {
        countryCode: 'IN',
        country: 'India',
        currency: 'INR',
        currencySymbol: '₹',
        currencyCode: 'INR',
        mobileLength: 10,
        mobileCountryCode: '+91',
    }
};

// Export the final configuration
export const config = baseConfig;

// Type definitions for better TypeScript support
export type Config = typeof config;
export type ApiConfig = typeof config.api;
export type RegionConfig = typeof config.region;

export const getEnvironment = (): string => {
    if (isDevelopment) return 'development';
    if (isProduction) return 'production';
    if (isTest) return 'test';
    return 'unknown';
};

// Default export
export default config;